<div
  (mouseenter)="pauseRotation()"
  (mouseleave)="resumeRotation()"
  *ngIf="features.length > 0"
>
  <section class="carousel-wrapper">
    <div
      class="carousel"
      [style.width.%]="features.length * 100"
      [style.transform]="'translateX(' + activeFeatureXCoordPercent + '%)'"
    >
      <div *ngFor="let feature of features" class="carousel-item">
        <img
          *ngIf="feature.imgUrl"
          [src]="feature.imgUrl | cdnPrefix: 'root'"
          class="carousel-item__img cg-margin-right-md"
          height="90"
          width="135"
          [alt]="feature.title"
        />
        <div>
          <div class="cg-font-size-mml cg-bold">{{ feature.title }}</div>
          <div
            class="cg-font-size-m cg-margin-top-sm"
            [innerHTML]="feature.content"
          ></div>
          <div class="cg-font-size-m cg-margin-top-sm">
            <a
              *ngIf="feature.resourceLink"
              cignaButton="link"
              style="padding: 0"
              target="resourcesWindow"
              [attr.href]="
                feature.path | resourceLink: { targetApp: 'both' } | async
              "
              [cignaTrackClicks]="[
                'trackEventOther',
                feature.linkText,
                'ac23433',
                {
                  eVar120: 'learn-more',
                  eVar119: 'PC9TP-996',
                  prop20: feature.title
                }
              ]"
              >{{ feature.linkText }}
            </a>
            <a
              *ngIf="feature.appLink"
              cignaButton="link"
              style="padding: 0"
              [routerLink]="feature.path.replace('app', '')"
              [cignaTrackClicks]="[
                'trackEventOther',
                feature.linkText,
                'ac23433',
                {
                  eVar120: 'learn-more',
                  eVar119: 'PC9TP-996',
                  prop20: feature.title
                }
              ]"
              >{{ feature.linkText }}
            </a>
            <button
              *ngIf="feature.videoUrl"
              cignaButton="link"
              style="padding: 0"
              [cignaTrackClicks]="[
                'trackEventOther',
                feature.linkText,
                'ac23433',
                {
                  eVar120: 'learn-more',
                  eVar119: 'PC9TP-996',
                  prop20: feature.title
                }
              ]"
              (click)="openVideoDialog(feature)"
            >
              {{ feature.linkText }}
            </button>
            <a
              *ngIf="
                !feature.resourceLink &&
                !feature.appLink &&
                !feature.videoUrl &&
                feature.link
              "
              cignaButton="link"
              target="_blank"
              style="padding: 0"
              [attr.href]="
                feature.path.startsWith('/assets/chcp/')
                  ? (feature.path | cdnPrefix: 'root')
                  : feature.path
              "
              [cignaTrackClicks]="[
                'trackEventOther',
                feature.linkText,
                'ac23433',
                {
                  eVar120: 'learn-more',
                  eVar119: 'PC9TP-996',
                  prop20: feature.title
                }
              ]"
              >{{ feature.linkText }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>

  <div class="controls-wrapper">
    <button
      type="button"
      cignaButton="link inline no-underline"
      class="cg-margin-right-sm"
      (click)="previousFeature()"
      aria-label="left"
      [cignaTrackClicks]="[
        'trackEventOther',
        'left arrow',
        'ac23563',
        {
          eVar120: 'dashboard-banner-selection-nav-arrows',
          eVar119: 'PC9TP-996',
          prop20: 'CHCP - Dashboard Dashboard'
        }
      ]"
    >
      <cigna-icon type="chevron-thin-left"></cigna-icon>
    </button>
    <button
      type="button"
      cignaButton="link inline no-underline"
      *ngFor="let feature of features; let i = index"
      class="control-dot"
      [cignaTrackClicks]="[
        'trackEventOther',
        'Banner Button Clicked',
        'ac23434',
        {
          eVar120: 'banner-selection-button',
          eVar119: 'PC9TP-996',
          prop20: features[activeFeatureIndex].title
        }
      ]"
      (click)="goToFeature(i)"
      [attr.aria-label]="'go to ' + feature.title + ' feature'"
    >
      <span [class.control-dot-active]="i === activeFeatureIndex"></span>
    </button>
    <button
      type="button"
      cignaButton="link inline no-underline"
      class="cg-margin-left-sm"
      (click)="nextFeature()"
      aria-label="right"
      [cignaTrackClicks]="[
        'trackEventOther',
        'right arrow',
        'ac23563',
        {
          eVar120: 'dashboard-banner-selection-nav-arrows',
          eVar119: 'PC9TP-996',
          prop20: 'CHCP - Dashboard Dashboard'
        }
      ]"
    >
      <cigna-icon type="chevron-thin-right"></cigna-icon>
    </button>
  </div>
</div>
